export const DYNAMICFIELDS = [
  {
    name: 'link',
    toolTip: 'Link for customers to see their place in line if the public waitlist view mode is enabled.',
    defaultLength: 'https://host.tablesready.com/p/waitlist/'.length + 8,
  },
  {
    name: 'name',
    toolTip: 'Name you\'ve entered for the customer.',
    defaultLength: 15,
  },
  {
    name: 'quoted',
    toolTip: 'Estimated wait time in minutes.',
    defaultLength: 2,
  },
  {
    name: 'size',
    toolTip: 'Size of the group.',
    defaultLength: 2,
  },
  {
    name: 'note',
    toolTip: 'Any notes you\'ve entered. Long notes may cause your messages to send in multiple parts.',
    defaultLength: 20,
  },
  {
    name: 'date',
    toolTip: 'The scheduled date and time for a reservation/appointment.',
    defaultLength: 25,
  },
  {
    name: 'business',
    toolTip: 'The name of your business.',
    defaultLength: 20,
  },
  {
    name: 'resource',
    toolTip: 'The name of the resource assigned to the party.',
    defaultLength: 20,
  },
  {
    name: 'service',
    toolTip: 'The name of the service assigned to the party.',
    defaultLength: 20,
  },
  {
    name: 'reservation',
    toolTip: 'The name of {reservation} label.',
    defaultLength: 20,
  },
];

export interface DynamicField {
  name: string;
  toolTip: string;
  defaultLength: number;
}
